// Lokalny hook rozszerzający usePostUsers o obsługę role_id i order_approval_user_id

import axios from 'api/axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

const requestKeys = ['email', 'first_name', 'last_name', 'role_id', 'order_approval_user_id'];

// parametry requestu do api - rozszerzone o nowe pola
export interface IRequest {
  email: string;
  first_name: string;
  last_name: string;
  role_id?: number;
  order_approval_user_id?: number;
}

// typ zwracanych danych
type IResponse = ICommandResponseSuccess;

const postUsersExtended = (data: IRequest): Promise<IResponse> =>
  axios.post('/users', data, { env: { FormData: { requestKeys: requestKeys } as any } });

export const usePostUsersExtended = (options?: UseMutationOptions<IResponse, IError, IRequest>) =>
  useMutation((data: IRequest) => postUsersExtended(data), options);
